import React, {useCallback, useEffect, useState} from 'react';
import {Box, Button, Collapse, IconButton, TableCell, TableRow, Typography} from '@mui/material';
import {QRCodeData, User} from '@app/model';
import {UserService} from '@app/services';
import {AxiosResponse} from 'axios';
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
import {useTranslation} from 'react-i18next';
import {QrCodeModal} from '../../../../modal/QrCodeModal';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {CleanersSelect} from '../../cleaners-select/CleanersSelect';
import {AssignmentUtil} from '@app/util';

interface HeadCleanersTableRowProps {
	headCleaner: User;
	cleaners: User[];
	getHeadCleaners(): void;
}

export function HeadCleanersTableRow(props: HeadCleanersTableRowProps) {
	const {headCleaner, cleaners, getHeadCleaners} = props;
	const {t} = useTranslation(['common', 'assignment']);

	const [isQrModalOpen, setIsQrModalOpen] = useState<boolean>(false);
	const [qrCodeData, setQrCodeData] = useState<QRCodeData | undefined>(undefined);
	const [open, setOpen] = useState<boolean>(false);

	const userService = UserService.get();

	const selectableCleaners = AssignmentUtil.getHeadCleanerSelectableCleaners(
		headCleaner,
		cleaners
	);

	const getQrCodeData = useCallback(() => {
		userService.getQrCodeData(headCleaner.id).then((res: AxiosResponse<QRCodeData>) => {
			setQrCodeData(res.data);
		});
	}, [userService]);

	useEffect(() => {
		if (headCleaner.hasQrCode) {
			getQrCodeData();
		}
	}, [getQrCodeData, headCleaner]);

	return (
		<>
			<TableRow>
				<TableCell>{headCleaner.displayname}</TableCell>
				<TableCell>
					{headCleaner.hasQrCode ? (
						<Button
							variant="outlined"
							startIcon={<QrCodeRoundedIcon />}
							onClick={() => setIsQrModalOpen(true)}
						>
							{t('common:button.qrCode')}
						</Button>
					) : (
						<Typography fontSize="0.875rem">{headCleaner.email}</Typography>
					)}
				</TableCell>
				<TableCell sx={{width: '250px'}}>
					<Box display="flex" alignItems="center">
						<Typography fontSize="0.875rem" mr={1}>
							{t('assignment:settings.headCleaner.assignCleaners')}
						</Typography>
						<IconButton
							aria-label="expand row"
							size="small"
							onClick={() => setOpen(!open)}
						>
							{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</IconButton>
					</Box>
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell sx={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<CleanersSelect
							headCleaner={headCleaner}
							cleaners={selectableCleaners}
							getHeadCleaners={getHeadCleaners}
						/>
					</Collapse>
				</TableCell>
			</TableRow>
			<QrCodeModal
				user={headCleaner}
				qrCodeData={qrCodeData}
				isModalOpen={isQrModalOpen}
				onClose={() => setIsQrModalOpen(false)}
			/>
		</>
	);
}
